import flatten from 'lodash.flatten';
import { withLatestFrom } from 'rxjs/operators/withLatestFrom';
import { switchMap } from 'rxjs/operators/switchMap';
import { of } from 'rxjs/observable/of';
import { destroy, stopSubmit, setSubmitFailed } from 'redux-form';
import getNextRouteForCartType from '../helpers/getNextRouteForCartType';

const checkErrorsToContinue = ([result, screenState]) => {
  if (result && result.type) {
    return of(result);
  }

  const results = Array.isArray(result) ? flatten(result) : [result];

  const { isDownloadOnly } = screenState;
  const errorMaps = results.filter((r) => !(!r || !r.errorMap));

  if (errorMaps.length) {
    const errorMap = errorMaps.reduce(
      (prev, curr) => ({ ...prev, ...curr.errorMap }),
      {}
    );

    return of(
      stopSubmit('checkout', errorMap),
      setSubmitFailed('checkout', Object.keys(errorMap))
    );
  }

  return of(destroy('checkout'), getNextRouteForCartType(isDownloadOnly));
};

const handleResults = (initialStream) => (resultStream) =>
  resultStream.pipe(
    withLatestFrom(initialStream),
    switchMap(checkErrorsToContinue)
  );

export default handleResults;
